import { render } from "./OnlineDonation.vue?vue&type=template&id=520a4b86&scoped=true"
import script from "./OnlineDonation.vue?vue&type=script&lang=js"
export * from "./OnlineDonation.vue?vue&type=script&lang=js"

import "./OnlineDonation.vue?vue&type=style&index=0&id=520a4b86&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520a4b86"]])

export default __exports__